export default __webpack_public_path__ + "static/media/menu_contact_selected.0d39de0e.svg";